import { render, staticRenderFns } from "./StatisticsCentreCancel.vue?vue&type=template&id=8da4de64&scoped=true"
import script from "./StatisticsCentreCancel.vue?vue&type=script&lang=js"
export * from "./StatisticsCentreCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da4de64",
  null
  
)

export default component.exports